"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "once", {
    enumerable: true,
    get: function() {
        return once;
    }
});
const uninitialized = Symbol('once');
function once(fn) {
    let result = uninitialized;
    return function() {
        if (result === uninitialized) {
            result = fn();
        }
        return result;
    };
}

//# sourceMappingURL=once.js.map